import { render } from "./right-sidebar.vue?vue&type=template&id=e32fc1d8&scoped=true&ts=true"
import script from "./right-sidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./right-sidebar.vue?vue&type=script&lang=ts&setup=true"

import "./right-sidebar.vue?vue&type=style&index=0&id=e32fc1d8&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e32fc1d8"],['__file',"src/views/chapter-list/right-sidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e32fc1d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e32fc1d8', __exports__)) {
    console.log('reload')
    api.reload('e32fc1d8', __exports__)
  }
  
  module.hot.accept("./right-sidebar.vue?vue&type=template&id=e32fc1d8&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('e32fc1d8', render)
  })

}


export default __exports__